// cspell: disable
export const authTranslations = {
  'en-GB': {
    auth: {
      loginOrRegister: 'Login or register',
      loginOrRegisterWithCourse: 'Login or register to get access to {{courseTitle}}',
      signInDescription: 'Sign in to your account or create a new one',
      orSignInWithEmail: 'Or sign in with your email',
      tabs: {
        login: 'Login',
        register: 'Register',
        guest: 'Guest'
      },
      form: {
        email: 'Email',
        password: 'Password',
        displayName: 'Display Name (Optional)',
        confirmPassword: 'Confirm Password',
        guestDescription: 'Continue as a guest to access courses with your order ID. No email or password required.',
        placeholders: {
          email: 'Enter your email',
          password: 'Enter your password',
          displayName: 'Enter your display name',
          createPassword: 'Create a password',
          confirmPassword: 'Confirm your password'
        },
        buttons: {
          signIn: 'Sign In',
          createAccount: 'Create Account',
          continueAsGuest: 'Continue as Guest'
        },
        validation: {
          requiredEmail: 'Please enter a valid email',
          requiredPassword: 'Please enter your password',
          requiredConfirmPassword: 'Please confirm your password',
          displayNameMaxLength: 'Display name cannot exceed 50 characters',
          passwordsDoNotMatch: 'Passwords do not match',
          agreeTermsRequired: 'You must agree to the Terms of Service and Privacy Policy',
          agreeMaterialsRequired: 'You must agree to this condition'
        },
        checkboxes: {
          agreeTerms: 'I agree to the',
          agreeTermsLegalNotice: 'Legal Notice',
          agreeTermsAnd: 'and',
          agreeTermsPrivacyPolicy: 'Privacy Policy',
          agreeMaterials: 'I agree not to share or download course materials',
          agreePromoMaterials: 'I would like to receive promotional materials and news about new products via email (optional)'
        }
      },
      messages: {
        loginSuccess: 'Logged in successfully!',
        guestLoginSuccess: 'Logged in as guest!',
        registerSuccess: 'Registered successfully!',
        loginFailed: 'Login failed',
        registerFailed: 'Registration failed',
        networkError: 'Please check your internet connection and try again',
        networkErrorTitle: 'No Internet Connection',
        tooManyRequests: 'Too many failed login attempts. Please try again in a few minutes',
        userNotFound: 'Email or password is incorrect',
        wrongPassword: 'Email or password is incorrect',
        emailAlreadyInUse: 'This email is already registered. Please log in instead',
        weakPassword: 'Password must be at least 6 characters',
        invalidEmail: 'Please enter a valid email address'
      }
    }
  },
  'en-US': {
    auth: {
      loginOrRegister: 'Login or register',
      loginOrRegisterWithCourse: 'Login or register to get access to {{courseTitle}}',
      signInDescription: 'Sign in to your account or create a new one',
      orSignInWithEmail: 'Or sign in with your email',
      tabs: {
        login: 'Login',
        register: 'Register',
        guest: 'Guest'
      },
      form: {
        email: 'Email',
        password: 'Password',
        displayName: 'Display Name (Optional)',
        confirmPassword: 'Confirm Password',
        guestDescription: 'Continue as a guest to access courses with your order ID. No email or password required.',
        placeholders: {
          email: 'Enter your email',
          password: 'Enter your password',
          displayName: 'Enter your display name',
          createPassword: 'Create a password',
          confirmPassword: 'Confirm your password'
        },
        buttons: {
          signIn: 'Sign In',
          createAccount: 'Create Account',
          continueAsGuest: 'Continue as Guest'
        },
        validation: {
          requiredEmail: 'Please enter a valid email',
          requiredPassword: 'Please enter your password',
          requiredConfirmPassword: 'Please confirm your password',
          displayNameMaxLength: 'Display name cannot exceed 50 characters',
          passwordsDoNotMatch: 'Passwords do not match',
          agreeTermsRequired: 'You must agree to the Terms of Service and Privacy Policy',
          agreeMaterialsRequired: 'You must agree to this condition'
        },
        checkboxes: {
          agreeTerms: 'I agree to the',
          agreeTermsLegalNotice: 'Legal Notice',
          agreeTermsAnd: 'and',
          agreeTermsPrivacyPolicy: 'Privacy Policy',
          agreeMaterials: 'I agree not to share or download course materials',
          agreePromoMaterials: 'I would like to receive promotional materials and news about new products via email (optional)'
        }
      },
      messages: {
        loginSuccess: 'Logged in successfully!',
        guestLoginSuccess: 'Logged in as guest!',
        registerSuccess: 'Registered successfully!',
        loginFailed: 'Login failed',
        registerFailed: 'Registration failed',
        networkError: 'Please check your internet connection and try again',
        networkErrorTitle: 'No Internet Connection',
        tooManyRequests: 'Too many failed login attempts. Please try again in a few minutes',
        userNotFound: 'Email or password is incorrect',
        wrongPassword: 'Email or password is incorrect',
        emailAlreadyInUse: 'This email is already registered. Please log in instead',
        weakPassword: 'Password must be at least 6 characters',
        invalidEmail: 'Please enter a valid email address'
      }
    }
  },
  de: {
    auth: {
      loginOrRegister: 'Anmelden oder registrieren',
      loginOrRegisterWithCourse: 'Anmelden oder registrieren, um Zugang zu {{courseTitle}} zu erhalten',
      signInDescription: 'Melden Sie sich in Ihrem Konto an oder erstellen Sie ein neues',
      orSignInWithEmail: 'Oder melden Sie sich mit Ihrer E-Mail an',
      tabs: {
        login: 'Anmelden',
        register: 'Registrieren',
        guest: 'Gast'
      },
      form: {
        email: 'E-Mail',
        password: 'Passwort',
        displayName: 'Anzeigename (Optional)',
        confirmPassword: 'Passwort bestätigen',
        guestDescription: 'Melden Sie sich als Gast an, um mit Ihrer Bestellnummer auf Kurse zuzugreifen. Keine E-Mail oder Passwort erforderlich.',
        placeholders: {
          email: 'Geben Sie Ihre E-Mail-Adresse ein',
          password: 'Geben Sie Ihr Passwort ein',
          displayName: 'Geben Sie Ihren Anzeigenamen ein',
          createPassword: 'Passwort erstellen',
          confirmPassword: 'Passwort bestätigen'
        },
        buttons: {
          signIn: 'Anmelden',
          createAccount: 'Konto erstellen',
          continueAsGuest: 'Als Gast fortfahren'
        },
        validation: {
          requiredEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
          requiredPassword: 'Bitte geben Sie Ihr Passwort ein',
          requiredConfirmPassword: 'Bitte bestätigen Sie Ihr Passwort',
          displayNameMaxLength: 'Der Anzeigename darf 50 Zeichen nicht überschreiten',
          passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
          agreeTermsRequired: 'Sie müssen den Nutzungsbedingungen und der Datenschutzerklärung zustimmen',
          agreeMaterialsRequired: 'Sie müssen dieser Bedingung zustimmen'
        },
        checkboxes: {
          agreeTerms: 'Ich stimme dem',
          agreeTermsLegalNotice: 'Impressum',
          agreeTermsAnd: 'und der',
          agreeTermsPrivacyPolicy: 'Datenschutzerklärung',
          agreeMaterials: 'Ich stimme zu, Kursmaterialien nicht zu teilen oder herunterzuladen',
          agreePromoMaterials: 'Ich möchte Werbematerialien und Nachrichten über neue Produkte per E-Mail erhalten (optional)'
        }
      },
      messages: {
        loginSuccess: 'Erfolgreich angemeldet!',
        guestLoginSuccess: 'Als Gast angemeldet!',
        registerSuccess: 'Erfolgreich registriert!',
        loginFailed: 'Anmeldung fehlgeschlagen',
        registerFailed: 'Registrierung fehlgeschlagen',
        networkError: 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut',
        networkErrorTitle: 'Keine Internetverbindung',
        tooManyRequests: 'Zu viele fehlgeschlagene Anmeldeversuche. Bitte versuchen Sie es in wenigen Minuten erneut',
        userNotFound: 'E-Mail oder Passwort ist falsch',
        wrongPassword: 'E-Mail oder Passwort ist falsch',
        emailAlreadyInUse: 'Diese E-Mail ist bereits registriert. Bitte melden Sie sich stattdessen an',
        weakPassword: 'Das Passwort muss mindestens 6 Zeichen lang sein',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
      }
    }
  },
  fr: {
    auth: {
      loginOrRegister: 'Connectez-vous ou inscrivez-vous',
      loginOrRegisterWithCourse: 'Connectez-vous ou inscrivez-vous pour accéder à {{courseTitle}}',
      signInDescription: 'Connectez-vous à votre compte ou créez-en un nouveau',
      orSignInWithEmail: 'Ou connectez-vous avec votre e-mail',
      tabs: {
        login: 'Connexion',
        register: 'Inscription',
        guest: 'Invité'
      },
      form: {
        email: 'E-mail',
        password: 'Mot de passe',
        displayName: 'Nom d\'affichage (Optionnel)',
        confirmPassword: 'Confirmer le mot de passe',
        guestDescription: 'Continuez en tant qu\'invité pour accéder aux cours avec votre numéro de commande. Aucun e-mail ou mot de passe requis.',
        placeholders: {
          email: 'Entrez votre e-mail',
          password: 'Entrez votre mot de passe',
          displayName: 'Entrez votre nom d\'affichage',
          createPassword: 'Créez un mot de passe',
          confirmPassword: 'Confirmez votre mot de passe'
        },
        buttons: {
          signIn: 'Se connecter',
          createAccount: 'Créer un compte',
          continueAsGuest: 'Continuer en tant qu\'invité'
        },
        validation: {
          requiredEmail: 'Veuillez entrer un e-mail valide',
          requiredPassword: 'Veuillez entrer votre mot de passe',
          requiredConfirmPassword: 'Veuillez confirmer votre mot de passe',
          displayNameMaxLength: 'Le nom d\'affichage ne peut pas dépasser 50 caractères',
          passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
          agreeTermsRequired: 'Vous devez accepter les Conditions d\'utilisation et la Politique de confidentialité',
          agreeMaterialsRequired: 'Vous devez accepter cette condition'
        },
        checkboxes: {
          agreeTerms: 'J\'accepte les',
          agreeTermsLegalNotice: 'Mentions légales',
          agreeTermsAnd: 'et la',
          agreeTermsPrivacyPolicy: 'Politique de confidentialité',
          agreeMaterials: 'J\'accepte de ne pas partager ou télécharger les matériaux du cours',
          agreePromoMaterials: 'Je souhaite recevoir des matériaux promotionnels et des informations sur les nouveaux produits par e-mail (optionnel)'
        }
      },
      messages: {
        loginSuccess: 'Connexion réussie !',
        guestLoginSuccess: 'Connecté en tant qu\'invité !',
        registerSuccess: 'Inscription réussie !',
        loginFailed: 'Échec de la connexion',
        registerFailed: 'Échec de l\'inscription',
        networkError: 'Veuillez vérifier votre connexion Internet et réessayer',
        networkErrorTitle: 'Pas de connexion Internet',
        tooManyRequests: 'Trop de tentatives de connexion échouées. Veuillez réessayer dans quelques minutes',
        userNotFound: 'L\'email ou le mot de passe est incorrect',
        wrongPassword: 'L\'email ou le mot de passe est incorrect',
        emailAlreadyInUse: 'Cet email est déjà enregistré. Veuillez vous connecter à la place',
        weakPassword: 'Le mot de passe doit contenir au moins 6 caractères',
        invalidEmail: 'Veuillez entrer une adresse email valide'
      }
    }
  },
  it: {
    auth: {
      loginOrRegister: 'Accedi o registrati',
      loginOrRegisterWithCourse: 'Accedi o registrati per accedere a {{courseTitle}}',
      signInDescription: 'Accedi al tuo account o creane uno nuovo',
      orSignInWithEmail: 'O accedi con la tua email',
      tabs: {
        login: 'Accedi',
        register: 'Registrati',
        guest: 'Ospite'
      },
      form: {
        email: 'E-mail',
        password: 'Password',
        displayName: 'Nome visualizzato (Opzionale)',
        confirmPassword: 'Conferma password',
        guestDescription: 'Accedi come ospite per accedere ai corsi con il tuo numero d\'ordine. Non è richiesta email o password.',
        placeholders: {
          email: 'Inserisci la tua e-mail',
          password: 'Inserisci la tua password',
          displayName: 'Inserisci il tuo nome visualizzato',
          createPassword: 'Crea una password',
          confirmPassword: 'Conferma la tua password'
        },
        buttons: {
          signIn: 'Accedi',
          createAccount: 'Crea account',
          continueAsGuest: 'Continua come ospite'
        },
        validation: {
          requiredEmail: 'Inserisci un\'e-mail valida',
          requiredPassword: 'Inserisci la tua password',
          requiredConfirmPassword: 'Conferma la tua password',
          displayNameMaxLength: 'Il nome visualizzato non può superare i 50 caratteri',
          passwordsDoNotMatch: 'Le password non corrispondono',
          agreeTermsRequired: 'Devi accettare i Termini di servizio e l\'Informativa sulla privacy',
          agreeMaterialsRequired: 'Devi accettare questa condizione'
        },
        checkboxes: {
          agreeTerms: 'Accetto le',
          agreeTermsLegalNotice: 'Note legali',
          agreeTermsAnd: 'e l\'',
          agreeTermsPrivacyPolicy: 'Informativa sulla privacy',
          agreeMaterials: 'Accetto di non condividere o scaricare i materiali del corso',
          agreePromoMaterials: 'Desidero ricevere materiali promozionali e notizie sui nuovi prodotti via e-mail (facoltativo)'
        }
      },
      messages: {
        loginSuccess: 'Accesso riuscito!',
        guestLoginSuccess: 'Accesso effettuato come ospite!',
        registerSuccess: 'Registrazione riuscita!',
        loginFailed: 'Accesso fallito',
        registerFailed: 'Registrazione fallita',
        networkError: 'Verificare la connessione Internet e riprovare',
        networkErrorTitle: 'Nessuna connessione Internet',
        tooManyRequests: 'Troppi tentativi di accesso falliti. Riprovare tra alcuni minuti',
        userNotFound: 'L\'email o la password non sono corretti',
        wrongPassword: 'L\'email o la password non sono corretti',
        emailAlreadyInUse: 'Questo email è già registrato. Accedi invece',
        weakPassword: 'La password deve contenere almeno 6 caratteri',
        invalidEmail: 'Inserisci un indirizzo email valido'
      }
    }
  },
  es: {
    auth: {
      loginOrRegister: 'Inicia sesión o regístrate',
      loginOrRegisterWithCourse: 'Inicia sesión o regístrate para acceder a {{courseTitle}}',
      signInDescription: 'Inicia sesión en tu cuenta o crea una nueva',
      orSignInWithEmail: 'O inicia sesión con tu correo electrónico',
      tabs: {
        login: 'Iniciar sesión',
        register: 'Registrarse',
        guest: 'Invitado'
      },
      form: {
        email: 'Correo electrónico',
        password: 'Contraseña',
        displayName: 'Nombre para mostrar (Opcional)',
        confirmPassword: 'Confirmar contraseña',
        guestDescription: 'Continúa como invitado para acceder a cursos con tu número de pedido. No se requiere correo electrónico ni contraseña.',
        placeholders: {
          email: 'Ingresa tu correo electrónico',
          password: 'Ingresa tu contraseña',
          displayName: 'Ingresa tu nombre para mostrar',
          createPassword: 'Crea una contraseña',
          confirmPassword: 'Confirma tu contraseña'
        },
        buttons: {
          signIn: 'Iniciar sesión',
          createAccount: 'Crear cuenta',
          continueAsGuest: 'Continuar como invitado'
        },
        validation: {
          requiredEmail: 'Ingresa un correo electrónico válido',
          requiredPassword: 'Ingresa tu contraseña',
          requiredConfirmPassword: 'Confirma tu contraseña',
          displayNameMaxLength: 'El nombre para mostrar no puede exceder 50 caracteres',
          passwordsDoNotMatch: 'Las contraseñas no coinciden',
          agreeTermsRequired: 'Debes aceptar los Términos de servicio y la Política de privacidad',
          agreeMaterialsRequired: 'Debes aceptar esta condición'
        },
        checkboxes: {
          agreeTerms: 'Acepto el',
          agreeTermsLegalNotice: 'Aviso Legal',
          agreeTermsAnd: 'y la',
          agreeTermsPrivacyPolicy: 'Política de privacidad',
          agreeMaterials: 'Acepto no compartir ni descargar los materiales del curso',
          agreePromoMaterials: 'Me gustaría recibir materiales promocionales e información sobre nuevos productos por correo electrónico (opcional)'
        }
      },
      messages: {
        loginSuccess: '¡Sesión iniciada exitosamente!',
        guestLoginSuccess: '¡Sesión iniciada como invitado!',
        registerSuccess: '¡Registro exitoso!',
        loginFailed: 'Error al iniciar sesión',
        registerFailed: 'Error en el registro',
        networkError: 'Por favor, verifica tu conexión a Internet e intenta de nuevo',
        networkErrorTitle: 'Sin conexión a Internet',
        tooManyRequests: 'Demasiados intentos fallidos de inicio de sesión. Por favor, intenta de nuevo en unos minutos',
        userNotFound: 'El correo electrónico o la contraseña es incorrecto',
        wrongPassword: 'El correo electrónico o la contraseña es incorrecto',
        emailAlreadyInUse: 'Este correo electrónico ya está registrado. Por favor, inicia sesión en su lugar',
        weakPassword: 'La contraseña debe tener al menos 6 caracteres',
        invalidEmail: 'Por favor, ingresa una dirección de correo electrónico válida'
      }
    }
  }
}